import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { outcomes } from '../data/copy';
export function FinalCtaSection() {
  return <section className="defer-paint w-full bg-coal py-12 sm:py-16" aria-labelledby="final-cta-heading" data-id="element-63" data-mp="3qtjemy0see2f">
      <div className="mx-auto max-w-4xl px-6 text-center" data-id="element-64" data-mp="3vsmbvwaizfzu">
        <p className="eyebrow text-gold" data-id="element-65" data-mp="3vruov9uzuql6">La próxima semana</p>
        <h2 id="final-cta-heading" className="mx-auto mt-5 max-w-3xl font-display text-[2rem] font-bold leading-[1.08] text-ivory sm:text-[2.6rem]" data-id="element-66" data-mp="2y5n8z3t8pbti">
          Podés seguir improvisando sesiones los domingos… o caminar a la pista{' '}
          <span className="text-gold" data-id="element-67" data-mp="381grd3tn3zj7">con tu sistema listo</span>.
        </h2>
        <p className="mx-auto mt-5 max-w-readable font-sans text-base leading-relaxed text-stone" data-id="element-68" data-mp="3cutetaml20ad">
          No necesitás ser el entrenador perfecto. Solo necesitás un sistema que
          te ayude a planificar rápido, entrenar con estructura y desarrollar
          atletas con coherencia.
        </p>

        <ul className="mx-auto mt-9 grid max-w-2xl gap-x-8 gap-y-3 text-left sm:grid-cols-2" data-id="element-69" data-mp="2daoze3cj2sxo">
          {outcomes.map(outcome => <li key={outcome.text} className={`flex items-start gap-2.5 font-sans text-[0.88rem] leading-relaxed ${outcome.positive ? 'font-semibold text-gold' : 'text-stone'}`} data-id="element-70" data-mp="28dp1wgtquyi6">
              {outcome.positive ? <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" strokeWidth={2.6} aria-hidden="true" data-id="element-71" data-mp="1ymu6omyisokl" /> : <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-track" strokeWidth={2.6} aria-hidden="true" data-id="element-72" data-mp="1umtt14j8whel" />}
              {outcome.text}
            </li>)}
        </ul>

        <CtaButton size="large" className="mt-10" data-id="element-73" data-mp="1kodzkuwqww1x">
          Obtené el Megapack ahora
        </CtaButton>
      </div>
    </section>;
}